import { useHistory, useLocation } from 'react-router-dom';
import { ResellerProgramInterest, ResellerType } from '@/types/gql-op-types';

const resellerTypes = Object.values(ResellerType);
const toResellerType = (type: string | null): ResellerType | null =>
  type && Object.values(ResellerType).includes(type as ResellerType) ? (type as ResellerType) : null;

export function useApplicationFormv2UrlSync() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // derive state from url
  const resellerTypeParam = queryParams.get('resellerType');
  const resellerType = toResellerType(resellerTypeParam);

  const isProgramInterest = (v: string): v is ResellerProgramInterest =>
    Object.values(ResellerProgramInterest).includes(v as ResellerProgramInterest);

  const programInterestParam = queryParams.get('programInterest');
  const programInterest = programInterestParam ? programInterestParam.split(',').filter(isProgramInterest) : [];

  const setResellerTypeUrlParam = (value: string) => {
    const params = new URLSearchParams(location.search);
    if (value === ResellerType.RESCUE) {
      params.set('resellerType', ResellerType.RESCUE);
    } else if (value === ResellerType.VET) {
      params.set('resellerType', ResellerType.VET);
    } else if (value === ResellerType.BREEDER) {
      params.set('resellerType', ResellerType.BREEDER);
    } else {
      params.delete('resellerType');
    }

    // program interest options are only for rescues
    if (value !== ResellerType.RESCUE) {
      params.delete('programInterest');
    }

    const query = params.toString();
    const search = query ? `?${query}` : '';

    history.replace({
      ...location,
      search,
    });
  };

  const setProgramInterestUrlParam = (value: string | ResellerProgramInterest) => {
    if (!isProgramInterest(value)) return;

    const values = programInterest.includes(value)
      ? programInterest.filter((v) => v !== value)
      : [...new Set([...programInterest, value])];

    const params = new URLSearchParams(location.search);
    if (values.length) {
      params.set('programInterest', values.join(','));
    } else {
      params.delete('programInterest');
    }

    const query = params.toString();
    const search = query ? `?${query}` : '';

    history.replace({
      ...location,
      search,
    });
  };

  return {
    resellerType,
    programInterest,
    setResellerTypeUrlParam,
    setProgramInterestUrlParam,
  };
}
